// Compact balance, with the allowance explained on hover or keyboard focus.
// AppCapsuleBtnGhost owns geometry, focus and shared coarse-pointer targets.
// The number includes top-ups; the pie is only the known monthly allowance.
export const BuildCreditBadge = {
  extends: ['AppCapsuleBtnGhost', 'TooltipTrigger'],
  tag: 'span',
  type: null,
  tabIndex: '0',
  compact: true,
  maxWidth: '100%',
  gap: 'Y',
  color: 'caption',
  cursor: 'default',
  tooltipPlacement: 'top',
  tooltipId: 'build-credit-balance',
  tooltipTextDeps: [
    (el, s) => s.root?._creditGuard,
    (el, s) => s.root?.lang,
    (el, s) => s.root?.roles
  ],
  tooltipText: (el, s) => (el.call('addAppBalanceLine', s.root) || {}).tooltip || '',
  ariaLabel: (el, s) => (el.call('addAppBalanceLine', s.root) || {}).tooltip || '',
  Pie: {
    boxSize: 'iconXs',
    flexShrink: '0',
    round: 'radiusPill',
    ariaHidden: 'true',
    hide: (el, s) => (el.call('addAppBalanceLine', s.root) || {}).fraction == null,
    background: (el, s) => {
      const fraction = (el.call('addAppBalanceLine', s.root) || {}).fraction || 0
      return `conic-gradient(var(--color-caption) ${fraction * 360}deg, var(--color-widgetPlate) 0deg)`
    }
  },
  Count: {
    tag: 'span',
    fontVariantNumeric: 'tabular-nums',
    textDeps: [(el, s) => s.root?._creditGuard, (el, s) => s.root?.lang],
    text: (el, s) => (el.call('addAppBalanceLine', s.root) || {}).count || ''
  }
}
